// Valyuta kodini EKRANDA ko'rsatish uchun belgiga o'giradi (faqat DISPLAY —
// saqlash/solishtirish/API so'rovlarida har doim asl kod ('USD') ishlatiladi).
// USD → "$", qolgan valyutalar (UZS, RUB...) o'z kodi bilan qoladi. Asosiy
// frontend'dagi curLabel bilan bir xil (client-app alohida ilova).
export function curLabel(c) {
  return c === 'USD' ? '$' : c;
}
